import Students from './Students';

const resource = {
  list: Students,
};

export default resource;
